module.exports = __webpack_public_path__ + "img/AdvancedSearch.fa549305.png";